export default __webpack_public_path__ + "static/media/Transporation_right.28d5342d.png";